import React from 'react';
import "./Footer.scss";

const Footer = () => {
    return (
        <div style={{marginTop:'20px', marginBottom:0}} className='footer   text-light b-0 pt-3  mt-5'>
         <p class="text-light pt-5">MedFashion Online Stores</p>   
         <p class="text-light">All Rights Reserved | MedFashion Online Stores</p>
         <p class="text-light ">Call Us: +44 7466 207558</p>
        </div>
    );
};

export default Footer;